import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {gotPdfJson, gotPdfSignatures} from "../actions/signatures";
import {PdfSignatureState} from "../types/pdfSignatures";

const initialState: PdfSignatureState = {
    total: 0,
};

export const pdfSignaturesReducer = createReducer(initialState)
    .handleAction(gotPdfSignatures, (state, action) => update(state, {
        signatures: {$set: action.payload.items},
        total: {$set: action.payload.total},
    }))
    .handleAction(gotPdfJson, (state, action) => update(state, {
        json: {$set: action.payload},
    }))
;
